import React from 'react';
import { StudentWithCheckIns } from './TeacherCheckInTool';
import styles from './StudentCheckInGrid.module.scss';
import cx from 'classnames';

interface StudentCheckInGridProps {
  students: StudentWithCheckIns[];
  selectedStudentId: string | null;
  onStudentSelect: (studentId: string) => void;
  isLoadingCheckIns: boolean;
}

const StudentCheckInGrid: React.FC<StudentCheckInGridProps> = ({
  students,
  selectedStudentId,
  onStudentSelect,
  isLoadingCheckIns,
}) => {
  const getInitials = (firstName: string, lastName?: string) => {
    const first = firstName?.[0] || '';
    const last = lastName?.[0] || '';
    return (first + last).toUpperCase();
  };

  const hasCheckedInToday = (student: StudentWithCheckIns) => {
    return student.todaysCheckIns && student.todaysCheckIns.length > 0;
  };

  return (
    <div className={styles.grid}>
      {students.map((student) => {
        const isCheckedIn = hasCheckedInToday(student);
        const isSelected = student.userId === selectedStudentId;

        return (
          <button
            key={student.userId}
            onClick={() => {
              console.log('Student card clicked:', {
                userId: student.userId,
                name: `${student.firstName} ${student.lastName}`,
              });
              onStudentSelect(student.userId);
            }}
            className={cx(styles.studentCard, {
              [styles.selected]: isSelected,
            })}
          >
            {/* Avatar */}
            <div className={styles.avatarContainer}>
              <div
                className={cx(styles.avatar, {
                  [styles.checkedIn]: isCheckedIn,
                  [styles.notCheckedIn]: !isCheckedIn,
                })}
              >
                {getInitials(student.firstName, student.lastName)}
              </div>
            </div>

            {/* Student Name */}
            <h3 className={styles.studentName}>
              {student.firstName} {student.lastName}
            </h3>

            {/* Check-in Status */}
            <div className={styles.statusContainer}>
              {isLoadingCheckIns ? (
                <span className={cx(styles.statusBadge, styles.loading)}>
                  <div className={styles.loadingSpinner}></div>
                  Loading...
                </span>
              ) : isCheckedIn ? (
                <span className={cx(styles.statusBadge, styles.checkedIn)}>
                  <svg fill='currentColor' viewBox='0 0 20 20'>
                    <path
                      fillRule='evenodd'
                      d='M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z'
                      clipRule='evenodd'
                    />
                  </svg>
                  Checked In ({student.todaysCheckIns.length})
                </span>
              ) : (
                <span className={cx(styles.statusBadge, styles.notCheckedIn)}>Not checked in</span>
              )}
            </div>

            {/* Selection indicator */}
            {isSelected && (
              <div className={styles.selectionIndicator}>
                <div className={styles.dot}></div>
              </div>
            )}
          </button>
        );
      })}
    </div>
  );
};

export default StudentCheckInGrid;
